import React from "react";
import PropTypes from "prop-types";
import Select from "react-select";
import translate from "./texts";

const RoleSelect = ({ onChange, roles, value }) => (
  <Select
    placeholder={translate("Select")}
    name="role"
    searchable={false}
    onChange={onChange}
    options={roles}
    valueKey="id"
    labelKey="name"
    clearable={false}
    value={value}
  />
);

RoleSelect.propTypes = {
  roles: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.object.isRequired,
};

export default RoleSelect;
